import { createNamespacedHelpers } from 'vuex';

const {
    mapGetters: mapSubAccountPermissionsGetters,
} = createNamespacedHelpers('subAccountPermissions');

export default {
    async mounted() {
        this.subAccountPermissions = this.getPermissionsResource(this.resourcePermissionsType);
    },
    data() {
        return {
            subAccountPermissions: null,
            resourcePermissionsType: 'DefaultType',
        };
    },
    computed: {
        ...mapSubAccountPermissionsGetters(['getPermissionsResource']),
        isSaveEnabled() {
            return this.subAccountPermissions && this.subAccountPermissions.allow_save === 1;
        },
        showAdminResources() {
          return this.subAccountPermissions && this.subAccountPermissions.use_admin_settings === 1;
        }
    },
}